import { render } from "./Authorization.vue?vue&type=template&id=85671cea&scoped=true"
import script from "./Authorization.vue?vue&type=script&lang=js"
export * from "./Authorization.vue?vue&type=script&lang=js"

import "./Authorization.vue?vue&type=style&index=0&id=85671cea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85671cea"]])

export default __exports__